import * as Yup from 'yup';

import { NumberConstraintEnum } from '@e-socna/data-layer';

import { useResolvableAmountSchema } from '../../ResolvableField/hooks/useResolvableAmountSchema.hook';
import { useResolvablePercentSchema } from '../../ResolvableField/hooks/useResolvablePercentSchema.hook';
import { ResolvableIdSchema } from '../../ResolvableField/schemas/resolvable-id.schema';

export const useResolvableServiceValueSchema = () => {
  const ResolvableAnySignAmountSchema = useResolvableAmountSchema(
    NumberConstraintEnum.Any,
  );

  const ResolvableNonNegativeAmountSchema = useResolvableAmountSchema(
    NumberConstraintEnum.NonNegative,
  );

  const ResolvablePercentSchema = useResolvablePercentSchema(
    NumberConstraintEnum.NonNegative,
  );

  const ResolvableServiceValueSchema = Yup.object().shape({
    priceExcludingVat: ResolvableAnySignAmountSchema.required('Prix HT requis'),
    discountPercentage: ResolvablePercentSchema.optional()
      .nullable()
      .default(undefined),
    discountAmount: ResolvableNonNegativeAmountSchema.optional()
      .nullable()
      .default(undefined),
    vatId: ResolvableIdSchema.required('TVA requise'),
  });

  return ResolvableServiceValueSchema;
};
